export const DISHWASHER_TEMPERATURE_DEFAULTS = [
  {
    type: 'prewash' as const,
    labelKey: 'tasks:labels.dishwasher.prewashTemperature',
    label: 'Prewash temperature',
    minValue: 35,
    maxValue: 40
  },
  {
    type: 'wash' as const,
    labelKey: 'tasks:labels.dishwasher.washTemperature',
    label: 'Wash temperature',
    minValue: 60,
    maxValue: 65
  },
  {
    type: 'rinse' as const,
    labelKey: 'tasks:labels.dishwasher.rinseTemperature',
    label: 'Rinse temperature',
    minValue: 80,
    maxValue: 85
  }
]

export type DishwasherTemperatureType = typeof DISHWASHER_TEMPERATURE_DEFAULTS[number]['type']

export type DishwasherConfiguration = {
  name: string
  temperatures: {
    type: DishwasherTemperatureType
    minValue: string
    maxValue: string
  }[]
}
